import axios from "axios";
const urls = process.env.REACT_APP_BASE_URL;

//아모 부리토 월렛주소 등록
export const requestWalletAddressAdd = (params) =>
  axios
    .post(`${urls}/mu/amo/wallet/register`, params)
    .then((response) => ({ response }))
    .catch((err) => ({ err }));

//아모 교환 페이지 정보
export const requestSwapInfo = (params) =>
  axios
    .post(`${urls}/mu/amo/swap/service`, params)
    .then((response) => ({ response }))
    .catch((err) => ({ err }));

//뮤포인트 -> 아모코인 교환
export const requestSwapMupToAmo = (params) =>
  axios
    .post(`${urls}/mu/amo/swap/mup2amo`, params)
    .then((response) => ({ response }))
    .catch((err) => ({ err }));

//아모 거래내역
export const requestAmoHistory = (params) =>
  axios
    .post(`${urls}/mu/user/amo/history`, params)
    .then((response) => ({ response }))
    .catch((err) => ({ err }));

// 아모 임시 입금 주소
export const requestTemporaryWalletAddr = (params) =>
  axios
    .post(`${urls}/mu/amo/ot/wallet`, params)
    .then((response) => ({ response }))
    .catch((err) => ({ err }));

//아모코인 일회용주소 입금 확인하기
export const requestSwapConfirm = (params) =>
  axios
    .post(`${urls}/mu/amo/swap/lookup`, params)
    .then((response) => ({ response }))
    .catch((err) => ({ err }));

//아모코인 -> 뮤포인트 확인 결과
export const requestSwapAmoToMup = (params) =>
  axios
    .post(`${urls}/mu/amo/swap/amo2mup/result`, params)
    .then((response) => ({ response }))
    .catch((err) => ({ err }));
